import { render, staticRenderFns } from "./ConfigDrawer.vue?vue&type=template&id=3b6d5814&scoped=true&"
import script from "./ConfigDrawer.vue?vue&type=script&lang=js&"
export * from "./ConfigDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d5814",
  null
  
)

export default component.exports